import { withStyles, makeStyles, createStyles } from '@material-ui/core/styles';
import { TableCell, Theme, Select } from '@material-ui/core';

type StyleProps = {
  matches2: boolean;
  tableSized: number;
  mainColor: string;
};

export const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    borderRight: '1px #CCCCCC solid'
  },
  body: {
    fontSize: 14,
    padding: 0,
    height: 60,
    borderRight: '1px #CCCCCC solid'
  }
}))(TableCell);

export const StyledSelect = withStyles(theme => ({
  root: {
    backgroundColor: '#fff',
    '&:focus': {
      backgroundColor: '#fff'
    }
  }
}))(Select);

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'scroll'
    },
    paper: {
      width: ({ matches2 }: StyleProps) => (matches2 ? 600 : '80%')
    },
    subContainer: {
      marginLeft: 15,
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row'
    },
    inputMainContainer: {
      display: 'flex',
      backgroundColor: '#F5F5F5',
      height: 60,
      alignItems: 'center',
      width: '100%'
    },
    inputMainContainerSub: {
      display: 'flex',
      backgroundColor: '#FFFFFF',
      height: 60,
      alignItems: 'center',
      width: '100%'
    },
    inputMainClientContainer: {
      display: 'flex',
      backgroundColor: '#F5F5F5',
      height: 100,
      alignItems: 'center',
      width: '100%'
    },
    inputContainer: {
      marginLeft: 10,
      marginRight: 10,
      paddingRight: 10,
      width: '100%'
    },
    inputAllCostPriceContainer: {
      marginLeft: 10,
      paddingRight: 3,
      width: '100%'
    },
    inputDetailContainer: {
      marginLeft: 10,
      marginRight: 10,
      paddingRight: 10,
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      width: '100%'
    },
    grossProfitMarginContainer: {
      marginLeft: 10,
      marginRight: 10,
      paddingRight: 10,
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    selectBoxStyleItems: {
      WebkitAppearance: 'menulist-button',
      backgroundColor: 'white',
      borderColor: '#c1c1c1',
      height: ({ tableSized }: StyleProps) =>
        tableSized === 100 ? 48 : tableSized === 50 ? 35 : 25
    },
    selectBoxCostItems: {
      WebkitAppearance: 'menulist-button',
      borderColor: '#c1c1c1',
      height: ({ tableSized }: StyleProps) =>
        tableSized === 100 ? 48 : tableSized === 50 ? 35 : 25,
      color: 'blue'
    },
    textMainContainer: {
      display: 'flex',
      backgroundColor: ({ mainColor }: StyleProps) => mainColor,
      width: '50%',
      height: 60,
      alignItems: 'center'
    },
    smallInputItems: {
      height: ({ tableSized }: StyleProps) =>
        tableSized === 100 ? 30 : tableSized === 25 ? 50 : 22,
      width: 80
    },
    smallQuantityInputItems: {
      height: ({ tableSized }: StyleProps) =>
        tableSized === 100 ? 30 : tableSized === 25 ? 50 : 22,
      width: 80,
      textAlign: 'right'
    },
    smallCostInputItems: {
      height: ({ tableSized }: StyleProps) =>
        tableSized === 100 ? 30 : tableSized === 25 ? 50 : 22,
      width: 80,
      color: 'blue'
    },
    smallmemoInputItems: {
      height: ({ tableSized }: StyleProps) =>
        tableSized === 100 ? 30 : tableSized === 25 ? 50 : 22,
      width: 80,
      color: 'blue'
    },
    inputGrossProfitMargin: {
      height: ({ tableSized }: StyleProps) =>
        tableSized === 100 ? 30 : tableSized === 25 ? 50 : 22,
      width: 70
    },
    inputGrossProfitMarginAlignRight: {
      height: ({ tableSized }: StyleProps) =>
        tableSized === 100 ? 30 : tableSized === 25 ? 50 : 22,
      width: 70,
      textAlign: 'right'
    },
    smallInputCostItems: {
      height: ({ tableSized }: StyleProps) =>
        tableSized === 100 ? 30 : tableSized === 25 ? 50 : 22,
      width: 80,
      color: 'blue'
    },
    smallInputCostQuantityItems: {
      height: ({ tableSized }: StyleProps) =>
        tableSized === 100 ? 30 : tableSized === 25 ? 50 : 22,
      width: 80,
      color: 'blue',
      textAlign: 'right'
    },
    inputMainContainerItems: {
      display: 'flex',
      backgroundColor: '#F5F5F5',
      height: ({ tableSized }: StyleProps) =>
        tableSized === 100 ? 60 : tableSized === 50 ? 35 : 20,
      alignItems: 'center',
      width: '100%'
    },
    inputMainContainerItemsSub: {
      display: 'flex',
      backgroundColor: '#FFFFFF',
      height: ({ tableSized }: StyleProps) =>
        tableSized === 100 ? 60 : tableSized === 50 ? 35 : 20,
      alignItems: 'center',
      width: '100%'
    },
    textContainer: {
      marginLeft: 15,
      color: '#FFFFFF',
      fontSize: 14
    },
    inputPostalCode: {
      height: 40,
      borderColor: '#c1c1c1',
      borderWidth: 1
    },
    inputMainContainer1: {
      display: 'flex',
      backgroundColor: '#F5F5F5',
      minHeight: 80,
      alignItems: 'center',
      width: '100%'
    },
    textMainContainer1: {
      display: 'flex',
      backgroundColor: ({ mainColor }: StyleProps) => mainColor,
      width: '50%',
      height: 80,
      alignItems: 'center'
    },
    textContainer1: {
      marginLeft: 15,
      color: '#FFFFFF',
      fontSize: 14
    },
    input: {
      height: 40,
      width: '100%',
      borderColor: '#c1c1c1',
      borderWidth: 1
    },
    input1: {
      height: 60,
      width: '100%'
    },
    input2: {
      height: 40,
      width: '100%'
    },
    inputAlignRight: {
      height: 40,
      width: '100%',
      borderColor: '#c1c1c1',
      borderWidth: 1,
      textAlign: 'right'
    },
    inputContainerSelectBox: {
      marginLeft: 10,
      marginRight: 13,
      width: '100%'
    },
    selectBoxStyle: {
      WebkitAppearance: 'menulist-button',
      backgroundColor: 'white',
      borderColor: '#c1c1c1',
      height: 48,
      width: '100%'
    },
    selectLayerType: {
      WebkitAppearance: 'menulist-button',
      backgroundColor: 'white',
      borderColor: '#c1c1c1',
      height: 38
    },
    fixedTextContainer: {
      fontSize: 14,
      marginLeft: 15
    },
    main: {
      minWidth: 700
    },
    aggreGateTable: {
      minWidth: 1100
    },
    companyInfoTable: {
      minWidth: 1200
    },
    companyInfoTableBody: {
      padding: 5
    },
    table: {
      padding: 8,
      backgroundColor: ({ mainColor }: StyleProps) => `${mainColor} !important`,
      color: '#FFFFFF',
      fontWeight: 'bold'
    },
    multiLinesTable: {
      padding: 0,
      backgroundColor: ({ mainColor }: StyleProps) => `${mainColor} !important`,
      color: '#FFFFFF',
      fontWeight: 'bold'
    },
    multiColCell: {
      width: '50%',
      height: '100%',
      display: 'flex',
      alignItems: 'center'
    },
    subTopCell: {
      padding: 8,
      borderBottom: '1px #F5F5F5 solid'
    },
    subTopCellAllView: {
      padding: 8,
      borderBottom: '1px #FFFFFF solid'
    },
    subCell: {
      padding: 8,
      borderBottom: '1px #CCCCCC solid'
    },
    tableBody: {
      backgroundColor: '#F5F5F5'
    },
    tableBodyItems: {
      backgroundColor: '#F5F5F5',
      height: ({ tableSized }: StyleProps) =>
        tableSized === 100 ? 100 : tableSized === 50 ? 75 : 50
    },
    tableBodyItemsMain: {
      backgroundColor: '#F5F5F5',
      height: ({ tableSized }: StyleProps) =>
        tableSized === 100 ? 100 : tableSized === 50 ? 75 : 50
    },
    tableBodyItemsSub: {
      backgroundColor: '#FFFFFF',
      height: ({ tableSized }: StyleProps) =>
        tableSized === 100 ? 100 : tableSized === 50 ? 75 : 50
    },
    tableTextAreaItems: {
      height: ({ tableSized }: StyleProps) =>
        tableSized === 100 ? 100 : tableSized === 50 ? 50 : 20,
      width: 250
    },
    tableBodyPrice: {
      backgroundColor: '#F5F5F5',
      paddingRight: 15
    },
    fixedTextCell: {
      fontSize: 14,
      padding: 15,
      height: 80
    },
    smallInput: {
      height: 30,
      width: 80
    },
    tableTextArea: {
      height: 100,
      width: 250
    },
    progress: {
      backgroundColor: '#c1c1c1',
      '& .MuiLinearProgress-barColorPrimary': {
        backgroundColor: ({ mainColor }: StyleProps) => mainColor
      }
    }
  })
);
